import React, { createContext, useContext } from 'react';

const ThemeContext = createContext({ dark: false, toggle: () => {} });

export const ThemeProvider = ({ children }) => (
  <ThemeContext.Provider value={{ dark: false, toggle: () => {} }}>
    {children}
  </ThemeContext.Provider>
);

export const useTheme = () => useContext(ThemeContext);
